import {Injectable} from '@angular/core';

import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {TranslateService} from '@ngx-translate/core';
import {DictModel} from '../dictionary/dict.model';

@Injectable()
export class EcvLanguageService {

  private currentLang$: BehaviorSubject<string>;
  private langToSwitch$: BehaviorSubject<string>;
  private language: string;
  private languageToSwitch: string;

  constructor(private translate: TranslateService) {
    this.language = localStorage.getItem('language') || 'pl';
    this.languageToSwitch = 'pl' === this.language ? 'en' : 'pl';
    this.currentLang$ = new BehaviorSubject<string>(this.language);
    this.langToSwitch$ = new BehaviorSubject<string>(this.languageToSwitch);
    this.setLanguage(this.language);
    this.translate.setDefaultLang(this.language);
  }

  setLanguage(lang: string) {
    this.language = lang;
    this.languageToSwitch = 'pl' === this.language ? 'en' : 'pl';
    localStorage.setItem('language', lang);
    this.translate.use(lang);
    this.currentLang$.next(this.language);
    this.langToSwitch$.next(this.languageToSwitch);
  }

  getLanguage(): string {
    return this.language;
  }

  getLanguage$() {
    return this.currentLang$;
  }

  getLanguageToSwitch$() {
    return this.langToSwitch$;
  }

  toggleLanguage() {
    if ('pl' === this.language) {
      this.setLanguage('en');
    } else {
      this.setLanguage('pl');
    }
  }

  /**
   * returns current language label for {@link DictModel}
   * @returns {string | string}
   */
  get descriptionSuffix() {
    return ('en' === this.language) ? 'descriptionEng' : 'description';
  }

  /**
   * pick the correct language from {@link DictModel} object, based on the current interface language
   * @param {DictModel} dictElem
   * @returns {string}
   */
  pickFromDictionary(dictElem: DictModel): string {
    return dictElem[this.descriptionSuffix].trim() || dictElem[this.descriptionSuffix].trim();
  }

}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-language.service.ts